export default __webpack_public_path__ + "static/media/spin.ee0e9e38.less";